import React from 'react';
import { Sidebar } from './Sidebar';
import { RightSidebar } from './RightSidebar';
import { MobileNav } from './MobileNav';
import { cn } from '../lib/cn';

interface LayoutProps {
  children: React.ReactNode;
  showRightSidebar?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({ children, showRightSidebar = true }) => {
  return (
    <div className="flex h-screen h-[100dvh] bg-bg overflow-hidden">
      {/* Left Sidebar */}
      <div className="hidden lg:flex w-[240px] xl:w-[260px] flex-shrink-0 h-full">
        <Sidebar />
      </div>

      {/* Main Content */}
      <main
        className={cn(
          'flex-1 min-w-0 h-full overflow-y-auto',
          'bg-bg text-text-primary',
          'pb-16 lg:pb-0'
        )}
      >
        {children}
      </main>

      {/* Right Sidebar */}
      {showRightSidebar && (
        <div className="hidden xl:flex w-[280px] 2xl:w-[320px] flex-shrink-0 h-full">
          <RightSidebar />
        </div>
      )}

      {/* Mobile Bottom Nav */}
      <MobileNav />
    </div>
  );
};
